export const portalV2OptInCookieName = 'acm-v2-opted-in';